export const overlayVariants = [
  'transition',
  'fixed inset-0',
  'z-50',
  'data-[state=open]:animate-in',
  'data-[state=closed]:animate-out',
  'data-[state=closed]:fade-out-0',
  'data-[state=open]:fade-in-0',
];
